import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ModalController} from '@ionic/angular';
import { ModUtils, ValidationUtils } from '../../../static/utils';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';


@Component({
  selector: 'app-form-custom',
  templateUrl: './form-custom.component.html',
  styleUrls: ['./form-custom.component.scss'],
})
export class FormCustomComponent implements OnInit {
  email:any=''
  mobile:any=''
  paternal_last_name:any=''
  mother_last_name:any=''
  name:any=''
  gender:any=''
  form:any = [
    /*{
    type: 'nombre',
    key: 'name',
    value: ''
  }, {
      type: 'apellido paterno',
      key: 'paternal_last_name',
      value: ''
    }, {
      type: 'apellido materno',
      key: 'mother_last_name',
      value: ''
    },*/ {
      type: 'celular',
      key: 'mobile',
      value: ''
    },
    /*{
      type: 'email',
      key: 'email',
      value: ''
    },*/
    {
      type: 'género',
      key: 'gender',
      value: ''
    }
]
 @Input() data: any;
  constructor(
  private authService:AuthService,private alertService:AlertService,private modalController: ModalController, private cdRef: ChangeDetectorRef,
  ) {
  
}
  ngOnInit() {
   
  }
  accept(){
    if(!this.form[0].value || !this.form[1].value){
      
      let filter=this.form.find(((item:any)=>!item.value))
      this.alertService.presentToastError('Falta llenar el campo '+filter.type)
       return
     }
  
   if(!ValidationUtils.validatePhoneNumber(this.form[0].value)){
         this.alertService.presentToastError('Escribe un número válido.')
         return
   }
    /*if(!ValidationUtils.validateEmail(this.form[1].value)){
         this.alertService.presentToastError('Escribe un correo válido (ejemplo: nombre@correo.com).')
         return
   }*/
  const myObject = this.form.reduce((obj, item) => {
  obj[item.key] = item.value;
  return obj;
}, {...this.data, whatsapp: true});

  this.alertService.presentLoading()
    this.authService.verifyDataEmployeeNomipay(myObject).subscribe((response:any) => {
      this.alertService.dismissLoading()
         if(response['status']==200){
          this.modalController.dismiss({...myObject,type:'success'});
         }else{
         this.alertService.presentToastError(response['errorMessage'])
         }
      },(error) => {
        console.log('err',error)
        this.alertService.dismissLoading();
        
      })
   
  }
  constrainPhoneNumber(value: number) {
    this.cdRef.detectChanges();
    this.form[0].value = ModUtils.constrainNumToDigitLength(value, 10);
  }
closeModal(){
    this.modalController.dismiss();
  }
}
